import React, { useState } from "react";
import Corretores from "./Corretores";
import CorretorDetalhe from "./CorretorDetalhe";

export default function CorretoresHub(props) {
  const [corretorDetalhe, setCorretorDetalhe] = useState(null);

  if (corretorDetalhe) {
    return (
      <CorretorDetalhe
        corretor={corretorDetalhe}
        corretores={props.corretores}
        times={props.times}
        currentUser={props.currentUser}
        setUser={props.setUser}
        setCorretores={props.setCorretores}
        onVoltar={() => setCorretorDetalhe(null)}
      />
    );
  }

  return (
    <Corretores
      corretores={props.corretores}
      setCorretores={props.setCorretores}
      times={props.times}
      currentUser={props.currentUser}
      onSelect={setCorretorDetalhe}
    />
  );
}
